import { render } from "./MenuSite.vue?vue&type=template&id=1ed0db85"
const script = {}

import "./MenuSite.vue?vue&type=style&index=0&id=1ed0db85&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__